import { connect } from "react-redux"

import InfiniteScroll from "./InfiniteScroll"

export default function buildListContainer(
    listItemComponent,
    shadowListItemComponent,
    pageListRequestActionCreator,
    itemRequestActionCreator,
    presentationAccessor,
    pagingAccessor = presentationAccessor,
    entitiesAccessor = pagingAccessor,
    checkSearchResults
) {
    const mapStateToProps = ({ paging, entities, presentation }) => {
        const { searchCriteria, isFetchingList, activeId } = presentation[
            presentationAccessor
        ]
        const pagingRequest = paging[pagingAccessor][searchCriteria] || {}
        const data = (pagingRequest.data || []).map(
            id => entities[entitiesAccessor][id]
        )

        return {
            itemComponent: listItemComponent,
            isFetching: isFetchingList,
            shadowComponent: shadowListItemComponent,
            data,
            itemStateProps: { activeId },
            pagingRequest,
            containerClassName: "widget-content list-group items-list auto",
            presentationAccessor,
            checkSearchResults
        }
    }

    const mapDispatchToProps = dispatch => {
        let defaultDispatch = {
            requestMoreData: pagingRequest =>
                dispatch(pageListRequestActionCreator(pagingRequest))
        }
        if (itemRequestActionCreator) {
            defaultDispatch = {
                ...defaultDispatch,
                itemActionProps: {
                    onClick: id => () => dispatch(itemRequestActionCreator(id))
                }
            }
        }
        return defaultDispatch
    }

    return connect(mapStateToProps, mapDispatchToProps)(InfiniteScroll)
}
